import '../../../../../functions/asg-framework/build_scripts/core-load-jquery';
import '../../../../../functions/asg-framework/global_plugins/jquery/jquery-migrate-3.3.2.min';
import '../../../../../functions/asg-framework/global_plugins/owl_carousel/2.3.4/owl.carousel.min';
import { slidebars } from '../../../../../functions/asg-framework/global_plugins/slidebars/slidebars.min';

// slidebars
window.slidebars = slidebars;
